// Wire contract — CMDB projection read filters (DATA-CONTRACTS §CMDB
// projections §Transport): equality only, on served fields, repeated values =
// IN. No search, no sort, no pagination — a projection is a snapshot,
// optionally sliced. The projects read takes no filters.
import { z } from 'zod';
import { csv, queryBool } from '../common/query.js';
import { AssetStatusSchema } from '../assets/requests.js';
import { AssetCategorySchema } from '../assets/categories.js';
import { SiteProjectionStatusSchema } from './responses.js';
export const SitesProjectionQuerySchema = z.object({
    status: csv(SiteProjectionStatusSchema),
    zone_id: csv(z.coerce.number().int().positive()),
    cluster_id: csv(z.coerce.number().int().positive()),
});
// Shared by the assets and devices reads (same filter axes).
export const AssetsProjectionQuerySchema = z.object({
    status: csv(AssetStatusSchema),
    model_id: csv(z.string()),
    category: csv(AssetCategorySchema),
    site_id: csv(z.string()),
});
export const ModelsProjectionQuerySchema = z.object({
    category: csv(AssetCategorySchema),
    is_network_device: queryBool,
    is_canonical: queryBool,
});
